module.exports = __webpack_public_path__ + "static/media/IMG_4262.46fc8bce.PNG";